import api from '../utils/api';

const healthService = {
  listProfiles: async () => {
    try {
      return await api.get('/api/health/profiles');
    } catch (error) {
      console.error('Error fetching health profiles:', error);
      throw error;
    }
  },
  createProfile: async (data) => {
    try {
      return await api.post('/api/health/profiles', data);
    } catch (error) {
      console.error('Error creating health profile:', error);
      throw error;
    }
  },
  getProfileByStudent: async (studentId) => {
    try {
      return await api.get(`/api/health/profiles/by-student/${studentId}`);
    } catch (error) {
      console.error('Error fetching health profile:', error);
      throw error;
    }
  },
  updateProfile: async (profileId, data) => {
    try {
      return await api.put(`/api/health/profiles/${profileId}`, data);
    } catch (error) {
      console.error('Error updating health profile:', error);
      throw error;
    }
  },
  deleteProfile: async (profileId) => {
    try {
      return await api.delete(`/api/health/profiles/${profileId}`);
    } catch (error) {
      console.error('Error deleting health profile:', error);
      throw error;
    }
  },

  listVisits: async (studentId) => {
    try {
      return await api.get('/api/health/visits', { params: { student_id: studentId } });
    } catch (error) {
      console.error('Error fetching clinic visits:', error);
      throw error;
    }
  },
  createVisit: async (data) => {
    try {
      return await api.post('/api/health/visits', data);
    } catch (error) {
      console.error('Error creating clinic visit:', error);
      throw error;
    }
  },
  updateVisit: async (visitId, data) => {
    try {
      return await api.put(`/api/health/visits/${visitId}`, data);
    } catch (error) {
      console.error('Error updating clinic visit:', error);
      throw error;
    }
  },
  deleteVisit: async (visitId) => {
    try {
      return await api.delete(`/api/health/visits/${visitId}`);
    } catch (error) {
      console.error('Error deleting clinic visit:', error);
      throw error;
    }
  },
  approveVisit: async (visitId) => {
    try {
      return await api.post(`/api/health/visits/${visitId}/approve`);
    } catch (error) {
      console.error('Error approving clinic visit:', error);
      throw error;
    }
  },
  rejectVisit: async (visitId, rejectionReason) => {
    try {
      return await api.post(`/api/health/visits/${visitId}/reject`, { rejection_reason: rejectionReason });
    } catch (error) {
      console.error('Error rejecting clinic visit:', error);
      throw error;
    }
  },

  listImmunizations: async (studentId) => {
    try {
      return await api.get('/api/health/immunizations', { params: { student_id: studentId } });
    } catch (error) {
      console.error('Error fetching immunization records:', error);
      throw error;
    }
  },
  createImmunization: async (data) => {
    try {
      return await api.post('/api/health/immunizations', data);
    } catch (error) {
      console.error('Error creating immunization record:', error);
      throw error;
    }
  },
  updateImmunization: async (recordId, data) => {
    try {
      return await api.put(`/api/health/immunizations/${recordId}`, data);
    } catch (error) {
      console.error('Error updating immunization record:', error);
      throw error;
    }
  },
  deleteImmunization: async (recordId) => {
    try {
      return await api.delete(`/api/health/immunizations/${recordId}`);
    } catch (error) {
      console.error('Error deleting immunization record:', error);
      throw error;
    }
  },

  // ---- Medication Administration Record (MAR) ----
  listMedications: async (visitId) => {
    try {
      return await api.get(`/api/health/visits/${visitId}/medications`);
    } catch (error) {
      console.error('Error fetching medication administrations:', error);
      throw error;
    }
  },
  createMedication: async (visitId, data) => {
    try {
      return await api.post(`/api/health/visits/${visitId}/medications`, data);
    } catch (error) {
      console.error('Error creating medication administration:', error);
      throw error;
    }
  },
  updateMedication: async (medicationId, data) => {
    try {
      return await api.put(`/api/health/medications/${medicationId}`, data);
    } catch (error) {
      console.error('Error updating medication administration:', error);
      throw error;
    }
  },
  deleteMedication: async (medicationId) => {
    try {
      return await api.delete(`/api/health/medications/${medicationId}`);
    } catch (error) {
      console.error('Error deleting medication administration:', error);
      throw error;
    }
  },

  // ---- Health Incidents ----
  listIncidents: async (params) => {
    try {
      return await api.get('/api/health/incidents', { params });
    } catch (error) {
      console.error('Error fetching health incidents:', error);
      throw error;
    }
  },
  createIncident: async (data) => {
    try {
      return await api.post('/api/health/incidents', data);
    } catch (error) {
      console.error('Error creating health incident:', error);
      throw error;
    }
  },
  getIncident: async (incidentId) => {
    try {
      return await api.get(`/api/health/incidents/${incidentId}`);
    } catch (error) {
      console.error('Error fetching health incident:', error);
      throw error;
    }
  },
  updateIncident: async (incidentId, data) => {
    try {
      return await api.put(`/api/health/incidents/${incidentId}`, data);
    } catch (error) {
      console.error('Error updating health incident:', error);
      throw error;
    }
  },
  deleteIncident: async (incidentId) => {
    try {
      return await api.delete(`/api/health/incidents/${incidentId}`);
    } catch (error) {
      console.error('Error deleting health incident:', error);
      throw error;
    }
  },

  // ---- Health Screening Campaigns ----
  listCampaigns: async (params) => {
    try {
      return await api.get('/api/health/campaigns', { params });
    } catch (error) {
      console.error('Error fetching screening campaigns:', error);
      throw error;
    }
  },
  createCampaign: async (data) => {
    try {
      return await api.post('/api/health/campaigns', data);
    } catch (error) {
      console.error('Error creating screening campaign:', error);
      throw error;
    }
  },
  getCampaign: async (campaignId) => {
    try {
      return await api.get(`/api/health/campaigns/${campaignId}`);
    } catch (error) {
      console.error('Error fetching screening campaign:', error);
      throw error;
    }
  },
  updateCampaign: async (campaignId, data) => {
    try {
      return await api.put(`/api/health/campaigns/${campaignId}`, data);
    } catch (error) {
      console.error('Error updating screening campaign:', error);
      throw error;
    }
  },
  bulkCreateScreeningResults: async (campaignId, results) => {
    try {
      return await api.post(`/api/health/campaigns/${campaignId}/results`, { results });
    } catch (error) {
      console.error('Error submitting screening results:', error);
      throw error;
    }
  },
  listScreeningResults: async (campaignId) => {
    try {
      return await api.get(`/api/health/campaigns/${campaignId}/results`);
    } catch (error) {
      console.error('Error fetching screening results:', error);
      throw error;
    }
  },
  getCampaignCoverage: async (campaignId) => {
    try {
      return await api.get(`/api/health/campaigns/${campaignId}/coverage`);
    } catch (error) {
      console.error('Error fetching campaign coverage:', error);
      throw error;
    }
  },
};

export default healthService;
